<template>
  <transition name="fade">
    <div
      v-if="showFlag"
      class="modal fade show efault-example-modal-left"
      id="default-example-modal-center"
      tabindex="-1"
      role="dialog"
      style="display: block; padding-right: 17px"
      aria-modal="true"
    >
      <div class="modalOverlay" @click="closeModal()"></div>
      <div class="modal-dialog modal-dialog-left" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              <slot name="title">modaltitle</slot>
            </h5>
            <button
              @click="closeModal()"
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true"><i class="fal fa-times"></i></span>
            </button>
          </div>
          <div class="modal-body">
            <slot name="body">...</slot>
          </div>
          <div class="modal-footer">
            <slot name="footer"></slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";

@Options({})
export default class Mo_modal_left_n extends Vue {
  /**
   * 表示用フラグ
   */
  public showFlag = false;

  async showModal(): Promise<void> {
    this.showFlag = true;
  }
  async closeModal(): Promise<void> {
    this.showFlag = false;
  }
}
</script>

<style scoped>
.modalOverlay {
  display: block;
  width: 100%;
  height: 100%;
  position: absolute;
  background-color: rgba(0, 0, 0, 0.5);
  opacity: 0.7;
  top: 0;
  left: 0;
  /* z-index: 9998; */
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
